/* eslint-disable no-constant-condition */
import React from "react";
import BootstrapTable from "react-bootstrap-table-next";
import PropTypes from "prop-types";

import PoonaWallaPaginator from "../PoonaWallaPaginator";
import PoonaWallaBasicLoader from "../PoonaWallaBasicLoader";
import PoonaWallaNoRecordsFound from "../PoonaWallaNoRecordsFound";

const PoonaWallaTable = ({
  columns = [],
  data = [],
  keyField = "id",
  sortingConfig = {},
  rowSelectionConfig,
  page,
  limit,
  count,
  isLoading,
  pagination,
  handlePagination,
  ...rest
}) => {
  return (
    <>
      {rowSelectionConfig ? (
        <BootstrapTable
          bootstrap4
          keyField={keyField}
          data={data}
          columns={columns}
          defaultSorted={sortingConfig}
          selectRow={rowSelectionConfig}
          rowStyle={{ overflowX: "scroll" }}
          noDataIndication={() =>
            isLoading ? (
              <PoonaWallaBasicLoader isLoading={isLoading} />
            ) : (
              <PoonaWallaNoRecordsFound />
            )
          }
          {...rest}
        />
      ) : (
        <BootstrapTable
          bootstrap4
          keyField={keyField}
          data={data}
          columns={columns}
          defaultSorted={sortingConfig}
          noDataIndication={() =>
            isLoading ? (
              <PoonaWallaBasicLoader isLoading={isLoading} />
            ) : (
              <PoonaWallaNoRecordsFound />
            )
          }
          {...rest}
        />
      )}
      {pagination && count ? (
        <PoonaWallaPaginator
          page={page}
          limit={limit}
          count={count}
          handlePagination={handlePagination}
          isLoading={isLoading}
        />
      ) : null}
    </>
  );
};

export default PoonaWallaTable;

PoonaWallaTable.propTypes = {
  columns: PropTypes.array.isRequired,
  data: PropTypes.array.isRequired,
  keyField: PropTypes.string,
  sortingConfig: PropTypes.object,
  rowSelectionConfig: PropTypes.object,
  page: PropTypes.number,
  limit: PropTypes.number,
  count: PropTypes.number,
  handlePagination: PropTypes.func,
  isLoading: PropTypes.bool,
  pagination: PropTypes.bool,
};
